import React, { ReactNode, useState } from 'react';
import { FC } from 'react';
import { classNames } from '../../../utils';
import { ToolTipDir } from '..';

export interface TooltipProps {
  label: string;
  dir?: ToolTipDir;
  className?: string;
  children?: ReactNode;
}

const ToolTipTheme: Record<ToolTipDir, string> = {
  UP: 'left-1/2 transform -translate-x-1/2 left-1/2 transform -translate-1/2 bottom-full mb-2',
  DOWN: 'left-1/2 transform -translate-x-1/2 top-full mt-2',
  LEFT: 'right-full mr-2',
  RIGHT: 'left-full ml-2',
};

const Tooltip: FC<TooltipProps> = ({
  children,
  label,
  className,
  dir = 'UP',
}) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const tipRef = React.createRef<HTMLDivElement>();

  function handleMouseEnter() {
    setShowTooltip(true);
  }

  function handleMouseLeave() {
    setShowTooltip(false);
  }

  return (
    <div className='relative flex items-center'>
      {showTooltip && (
        <div
          className={classNames(
            'whitespace-no-wrap absolute z-30 w-44 rounded border border-gray-light border-opacity-50 bg-white px-4 py-2 text-left text-sm font-normal text-gray shadow-md',
            ToolTipTheme[dir],
            className ? className : '',
          )}
          ref={tipRef}
        >
          {label}
        </div>
      )}

      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
